<script setup lang="ts">
import { useNotificationStore } from '@/stores/notifications/store'
import NotificationGroup from './NotificationGroup.vue'

const notificationStore = useNotificationStore()
</script>

<template>
  <NotificationGroup
    :notifications="notificationStore.notifications"
    @close="notificationStore.remove"
  />
</template>
